import './PageHeader.css';

interface PageHeaderProps {
    title: string;
    path: string;
    name: string;
    backgroundImage?: string;
}

export default function PageHeader({ title, path, name, backgroundImage }: PageHeaderProps) {

    const headerStyle = backgroundImage ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .4)), url(${backgroundImage})`
    } : {};

    return (
        <div className="page-header" style={headerStyle}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2>{title}</h2>
                    </div>
                    <div className="col-12">
                        <a href="/">Home</a>
                        <a href={path}>{name}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}